export interface PdpSizeOption {
  key: string;
  value: string;
}

export function parseSizeList(customizationOptions: unknown): PdpSizeOption[] {
  if (!customizationOptions || typeof customizationOptions !== 'object') return [];
  const opts = customizationOptions as Record<string, unknown>;
  const sizes = opts['size'];
  if (!Array.isArray(sizes)) return [];
  return sizes as PdpSizeOption[];
}
